// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useEffect, useMemo, useRef, Fragment } from 'react';
import { useLocation, useHistory, Link } from 'react-router-dom';
import cn from 'classnames';
import hopt from 'hola_opt';
import config from 'pub_config';
import zutil from '/util/util.js';
import string from '/util/string.js';
import www_util from './util.js';
import Icon_loupe from './img/svg/icon/loupe.svg';
import Icon_thumb_up from './img/svg/icon/thumb_up.svg';
import Icon_ios from './img/svg/pl/ic-ios.svg';
import Icon_mac from './img/svg/pl/ic-mac.svg';
import Icon_windows from './img/svg/pl/ic-windows.svg';
import Icon_chrome from './img/svg/pl/ic-chrome.svg';
import Icon_android from './img/svg/pl/ic-android.svg';
import Icon_androidtv from './img/svg/pl/ic-androidtv.svg';
import { Svg } from './shared/svg';
import { convert_to_tree } from './support_util.js';
import { Button } from '../../shared/button';
import { Tooltip } from './lib/tooltip';
import * as content_ from './support/content.js';
import './css/support.less';
var faq_entries = [{
  tag: 'h2',
  id: 'intro',
  title: 'Introduction to Hola'
}, {
  tag: 'h3',
  id: 'intro-whatis',
  title: 'What is Hola?'
}, {
  tag: 'h3',
  id: 'intro-os',
  title: 'Which operating systems, browsers and devices can I use ' + 'Hola on?',
  short: 'Supported platforms'
}, {
  tag: 'h3',
  id: 'intro-cost',
  title: 'Is Hola free?'
}, {
  tag: 'h3',
  id: 'intro-trial',
  title: 'How do the time limits work on Hola\'s free product?'
}, {
  tag: 'h3',
  id: 'intro-how-it-works',
  title: 'How does Hola technology work?'
}, {
  tag: 'h3',
  id: 'intro-lum-cost',
  title: 'How come Hola has a free version?'
}, {
  tag: 'h3',
  id: 'peer-to-peer-safe',
  title: 'Is it safe to be part of the Peer-to-Peer network?'
}, {
  tag: 'h3',
  id: 'intro-idle-bw',
  title: 'How much bandwidth does Hola use?'
}, {
  tag: 'h3',
  id: 'intro-ads',
  title: 'Why we don\'t sell ads?'
}, {
  tag: 'h3',
  id: 'intro-bandwidth',
  title: 'Is Hola using my bandwidth?'
}, {
  tag: 'h3',
  id: 'intro-premium',
  title: 'Can I use Hola and not be a peer contributing to the ' + 'community?',
  short: 'Not a peer'
}, {
  tag: 'h3',
  id: 'opt-out',
  title: 'What if I don’t want to allow Hola to use my network?',
  short: 'What if I don’t want to allow Hola to use my network?'
}, {
  tag: 'h3',
  id: 'intro-howfree',
  title: 'How can Hola be free?'
}, {
  tag: 'h3',
  id: 'intro-more',
  title: 'How can Hola offer products for free and with no ads?'
}, {
  tag: 'h3',
  id: 'products-that-are-not-peer-to-peer',
  title: 'Are there Hola products that are not part ' + 'of the Peer-to-Peer network?'
}, {
  tag: 'h3',
  id: 'is-hola-swapping-ips',
  title: 'Is Hola swapping people\'s IP addresses?'
}, {
  tag: 'h3',
  id: 'is-it-safe',
  title: 'Is it safe?'
}, {
  tag: 'h3',
  id: 'security-and-encryption',
  title: 'Security and encryption'
}, {
  tag: 'h3',
  id: 'intro-money',
  title: 'How does Hola make money?'
}, {
  tag: 'h3',
  id: 'intro-love',
  title: 'I love the Hola service. How can I share my love?',
  short: 'Share hola'
}, {
  tag: 'h3',
  id: 'intro-business',
  title: 'How can I use Hola for my business?',
  short: 'Use Hola for my business'
}, {
  tag: 'h3',
  id: 'intro-luminati',
  title: 'What are some typical use cases for the Bright Data services?',
  short: 'Bright Data use cases'
}, {
  tag: 'h2',
  id: 'ts',
  title: 'General troubleshooting'
}, {
  tag: 'h3',
  id: 'ts-reset_pass',
  title: 'I forgot my password, how can I reset it?',
  short: 'Reset password'
}, {
  tag: 'h3',
  id: 'ts-multi_devices',
  title: 'Can I use my account on multiple devices?',
  short: 'Multiple devices'
}, {
  tag: 'h3',
  id: 'ts-change_email',
  title: 'Can you change the email address?',
  short: 'Change email'
}, {
  tag: 'h3',
  id: 'ts-vpn_ts',
  title: 'Hola is on, but I still can\'t access the web page I want ' + 'to see. What should I do?',
  short: 'Troubleshooting'
}, {
  tag: 'h3',
  id: 'ts-holaicon',
  title: 'Hola\'s icon disappeared from my browser. What should ' + 'I do?',
  short: 'Hola\'s icon disappeared'
}, {
  tag: 'h3',
  id: 'ts-settings',
  title: 'I get this message: \'Hola cannot work because another ' + 'extension is controlling your proxy settings\'. What should ' + 'I do?',
  short: 'Other extension'
}, {
  tag: 'h3',
  id: 'ts-reload',
  title: 'I get this message: \'There seems to be an error - Reload ' + 'Hola\'. What should I do?',
  short: '\'Reset Hola\' message'
}, {
  tag: 'h3',
  id: 'ts-premium',
  title: 'I have a Premium membership. Why is my status not updated ' + 'to Premium?',
  short: 'Premium status'
}, {
  tag: 'h3',
  id: 'ts-premium_no_recurring',
  title: 'Is it possible to pay for Premium without automatically ' + 'recurring payments?',
  short: 'Premium without recurring payment'
}, {
  tag: 'h3',
  id: 'ts-updates',
  title: 'How do I keep Hola\'s version updated to the latest ' + 'version?',
  short: 'Latest version'
}, {
  tag: 'h3',
  id: 'ts-reporting',
  title: 'Which information should I provide to Hola when ' + 'reporting a problem?',
  short: 'Reporting a problem'
}, {
  tag: 'h3',
  id: 'ts-incognito',
  title: 'How to access sites in Chrome Incognito?',
  short: 'Incognito'
}, {
  tag: 'h3',
  id: 'ts-install',
  title: 'I can\'t install the Hola client (exe)',
  short: 'Can\'t install Hola client'
}, {
  tag: 'h3',
  id: 'ts-uninstall',
  title: 'How do I uninstall Hola?',
  short: 'How do I uninstall Hola?'
}, {
  tag: 'h3',
  id: 'ts-autostart',
  title: 'How do I stop Hola from starting automatically when ' + 'Windows starts?',
  short: 'Cancel autostart'
}, {
  tag: 'h3',
  id: 'ts-failed_to_connect',
  title: 'How can I fix \'Failed to connect\' in Hola?',
  short: 'Failed to connect'
}, {
  tag: 'h3',
  id: 'ts-email_verify',
  title: 'I received an account verification email, but the link is ' + 'not working',
  short: 'Email verification'
}, {
  tag: 'h3',
  id: 'ts-email_2step_verification',
  title: 'How do I turn off 2-Step Verification?',
  short: '2-step verification'
}, {
  tag: 'h3',
  id: 'ts-vulnerability',
  title: 'Reporting vulnerability'
}, {
  tag: 'h3',
  id: 'ts-idea',
  title: 'I have feedback or an idea for Hola',
  short: 'Feedback or idea'
}, {
  tag: 'h3',
  id: 'ts-remove-acc',
  title: 'Removing my Hola account'
}, {
  tag: 'h2',
  id: 'ts-hola-browser',
  title: 'Hola Browser'
}, {
  tag: 'h3',
  id: 'ts-how-browser-works',
  title: 'How does it work?'
}, {
  tag: 'h3',
  id: 'ts-default-search-engine',
  title: 'Default search engine'
}, {
  tag: 'h3',
  id: 'ts-uninstall-browser',
  title: 'How do I uninstall the Hola browser?'
}, {
  tag: 'h2',
  id: 'ts_hola_android',
  title: 'Hola on Android',
  note: '* only relevant for versions installed via Samsung Galaxy ' + 'Store, Huawei or Amazon'
}, {
  tag: 'h3',
  id: 'ts_peer_network',
  title: 'When does my device contribute to the Hola peer network?'
}, {
  tag: 'h3',
  id: 'ts_peer_network_mobile',
  title: 'Will my cellular plan be used by the Hola peer network?'
}, {
  tag: 'h2',
  id: 'ts_and',
  title: 'Android troubleshooting'
}, {
  tag: 'h3',
  id: 'ts_clear_history',
  title: 'How can I clear my browsing history?',
  short: 'Clear browsing history'
}, {
  tag: 'h3',
  id: 'ts_howto_use',
  title: 'How do I use the Hola built-in browser?',
  short: 'Hola built-in browser'
}, {
  tag: 'h3',
  id: 'ts_and-not_working',
  title: 'Hola is not working for me'
}, {
  tag: 'h3',
  id: 'ts_and-popular',
  title: 'I am not interested in seeing \'Popular apps\', can I ' + 'hide it?',
  short: 'Hide \'Popular apps\''
}, {
  tag: 'h3',
  id: 'ts_and-disable',
  title: 'How can I temporarily disable Hola app?',
  short: 'Disable Hola'
}, {
  tag: 'h3',
  id: 'ts_and-uninstall',
  title: 'How do I uninstall Hola?',
  short: 'How do I uninstall Hola?'
}, {
  tag: 'h3',
  id: 'ts_and-apps',
  title: 'How do I use Hola on Android apps that I cannot find ' + 'on the store?',
  short: 'Find apps'
}, {
  tag: 'h3',
  id: 'ts_and-logs',
  title: 'Bug report'
}, {
  tag: 'h2',
  id: 'ts_ios',
  title: 'iOS troubleshooting',
  short: 'iOS FAQ'
}, {
  tag: 'h3',
  id: 'ts_ios-ios',
  title: 'I have a problem with Hola on iOS, what should I do?'
}, {
  tag: 'h2',
  id: 'billing',
  title: 'Billing FAQ'
}, {
  tag: 'h3',
  id: 'billing-faq',
  title: 'I have a billing question, what should I do?',
  short: 'Billing question'
}, {
  tag: 'h2',
  id: 'vpn',
  title: 'Hola'
}, {
  tag: 'h3',
  id: 'vpn-what_is_hola',
  title: 'What is the Hola?'
}, {
  tag: 'h3',
  id: 'vpn-use',
  title: 'How do I use Hola?'
}, {
  tag: 'h3',
  id: 'vpn-popup',
  title: 'Why do I get a Hola popup on some websites, asking ' + 'if I want to access this page using Hola?',
  short: 'Popup'
}, {
  tag: 'h3',
  id: 'sec-legit',
  title: 'How does Hola ensure the legitimate use of its ' + 'consumer network?',
  short: 'Ensure customer legitimate use'
}, {
  tag: 'h3',
  id: 'sec-torrents',
  title: 'Are torrents supported?',
  short: 'Torrents support'
}, {
  tag: 'h3',
  id: 'sec-permissions',
  title: 'Why does Hola need the various permissions for the ' + 'Chrome extension and the Android app?',
  short: 'Chrome/Android permissions'
}, {
  tag: 'h3',
  id: 'sec-caching',
  title: 'Does Hola share any of my personal information ' + 'with the rest of the Hola community?',
  short: 'Personal information'
}, {
  tag: 'h3',
  id: 'sec-antivirus',
  title: 'My antivirus software is marking some files related to ' + 'Hola as unsafe, are they?',
  short: 'Antivirus mark Hola files as unsafe'
}, {
  tag: 'h3',
  id: 'sec-resks',
  title: 'What are the risks of a community powered commercial network?',
  short: 'What are the risks?'
}, {
  tag: 'h3',
  id: 'sec-sco',
  title: 'What is the role of Hola’s Chief Security Officer?',
  short: 'Hola\'s Chief Security Officer'
}, {
  tag: 'h3',
  id: 'sec-bounty',
  title: 'What is the Hola vulnerability bounty program?',
  short: 'Bounty program'
}, {
  tag: 'h2',
  id: 'premium',
  title: 'Hola Premium'
}, {
  tag: 'h3',
  id: 'premium-compat',
  title: 'Which platforms does Hola Premium support?',
  short: 'Supported platforms'
}, {
  tag: 'h3',
  id: 'premium-multiple',
  title: 'Can I use my account on multiple devices?',
  short: 'Multiple device'
}, {
  tag: 'h3',
  id: 'premium-security_protocols',
  title: 'Which security protocols Hola Premium support?',
  short: 'Security protocols'
}, {
  tag: 'h3',
  id: 'premium-ports',
  title: 'Which ports to unblock for network traffic to pass-through?',
  short: 'Ports to use on firewall'
}, {
  tag: 'h3',
  id: 'premium-appearfree',
  title: 'I subscribed to Premium, but my account is still showing ' + 'that I am a free user. Why?',
  short: 'Not showing Premium'
}, {
  tag: 'h3',
  id: 'premium-slowconn',
  title: 'I think my Hola Premium connection is slow. What can ' + 'I do?',
  short: 'Slow connection'
}, {
  tag: 'h3',
  id: 'premium-secwarn',
  title: 'When I connect to some sites, they warn me of ' + 'suspicious activity. Why?',
  short: 'Security warnings'
}, {
  tag: 'h3',
  id: 'premium-family',
  title: 'Can I share my account with my family? Will they see ' + 'my online activity?',
  short: 'Family package'
}, {
  tag: 'h3',
  id: 'premium-portal',
  title: 'How can I manage my account?',
  short: 'User portal'
}, {
  tag: 'h3',
  id: 'premium-cancel',
  title: 'How can I cancel my subscription',
  short: 'Cancelling subscription'
}, {
  tag: 'h3',
  id: 'refund-policy',
  title: 'Refund & Cancelation policy'
}, {
  tag: 'h3',
  id: 'premium-support',
  title: 'How can I get technical support?',
  short: 'Getting help'
}, {
  tag: 'h2',
  id: 'gb',
  title: 'GameBoost - Hola for Gamers: Overview',
  short: 'GameBoost: Overview'
}, {
  tag: 'h3',
  id: 'gb-what-is',
  title: 'What is GameBoost - Hola for Gamers?'
}, {
  tag: 'h3',
  id: 'gb-vs-vpn',
  title: 'How does GameBoost - Hola for Gamers differ from ' + 'traditional privacy VPNs?',
  short: 'GameBoost vs. privacy VPNs'
}, {
  tag: 'h3',
  id: 'gb-free',
  title: 'Why is GameBoost - Hola for Gamers 100% free?',
  short: 'Why is GameBoost free?'
}, {
  tag: 'h2',
  id: 'gb-features',
  title: 'GameBoost - Hola for Gamers: Core Features',
  short: 'GameBoost: Core Features'
}, {
  tag: 'h3',
  id: 'gb-qos',
  title: 'How does GameBoost - Hola for Gamers improve gaming ' + 'connection stability (QoS)?',
  short: 'Connection stability (QoS)'
}, {
  tag: 'h3',
  id: 'gb-games',
  title: 'How does the service handle game selection and metrics?',
  short: 'Game selection and metrics'
}, {
  tag: 'h3',
  id: 'gb-keys',
  title: 'Does GameBoost offer a CD-key deal aggregator?',
  short: 'CD-key deal aggregator'
}, {
  tag: 'h2',
  id: 'gb-security',
  title: 'GameBoost - Hola for Gamers: Security, Anti-Cheat & ' + 'Anti-Abuse',
  short: 'GameBoost: Security & Anti-Cheat'
}, {
  tag: 'h3',
  id: 'gb-anticheat',
  title: 'Will GameBoost - Hola for Gamers trigger anti-cheat ' + 'software (Riot Vanguard, EAC)?',
  short: 'Anti-cheat compatibility'
}, {
  tag: 'h3',
  id: 'gb-cheating',
  title: 'Is GameBoost - Hola for Gamers intended for ban evasion ' + 'or cheating?',
  short: 'Ban evasion or cheating'
}, {
  tag: 'h3',
  id: 'gb-ports',
  title: 'How does GameBoost manage ports and IP pools?',
  short: 'Ports and IP pools'
}, {
  tag: 'h2',
  id: 'gb-privacy',
  title: 'GameBoost - Hola for Gamers: Privacy, Compliance & ' + 'Installation',
  short: 'GameBoost: Privacy & Installation'
}, {
  tag: 'h3',
  id: 'gb-logs',
  title: 'Does GameBoost - Hola for Gamers log personal browsing ' + 'data?',
  short: 'Browsing data logging'
}, {
  tag: 'h3',
  id: 'gb-install',
  title: 'How do I cleanly install or uninstall GameBoost?',
  short: 'Install and uninstall'
}, {
  tag: 'h2',
  id: 'misc',
  title: 'Misc.'
}, {
  tag: 'h3',
  id: 'misc-other_vpn',
  title: 'Can I use Hola together with another service?',
  short: 'Hola with another service'
}, {
  tag: 'h3',
  id: 'misc-register',
  title: 'When I\'m using Hola, do I still need to register ' + 'as a user or pay the website I\'m watching?',
  short: 'Using pay sites with Hola'
}, {
  tag: 'h3',
  id: 'misc-vm',
  title: 'Can I run Hola on a virtual machine? Can I run it ' + 'on both the host and guest systems simultaneously?',
  short: 'Hola on VM'
}, {
  tag: 'h3',
  id: 'misc-router',
  title: 'Can I use Hola on my SmartTV, my gaming console or ' + 'my router?',
  short: 'Hola on router'
}, {
  tag: 'h3',
  id: 'misc-changelog',
  title: 'How can I remain updated as to the latest improvements and ' + 'new product features?',
  short: 'Updates'
}];
var faq_ios_entries = ({
  os
}) => [{
  tag: 'h2',
  id: 'start',
  title: `Hola ${os} App FAQ`
}, {
  tag: 'h3',
  id: 'ts_howto_use',
  short: 'How do I use it?',
  title: 'How to use the Hola?'
}, {
  tag: 'h3',
  id: 'otherdevices',
  title: `Can I use my ${os} account on other devices?`,
  short: 'Can I use Hola on other devices'
}, {
  tag: 'h3',
  id: 'cost',
  title: `Is Hola ${os} free?`,
  short: 'Cost'
}, {
  tag: 'h3',
  id: 'authentication',
  title: 'The device is asking me for authentication information, what ' + 'is it?',
  short: 'Authentication'
}, {
  tag: 'h3',
  id: 'connect',
  title: 'I can\'t get the Hola to connect, what should I do?',
  short: 'I can\'t get the Hola to connect'
}, {
  tag: 'h3',
  id: 'pay',
  title: 'Is it possible to pay for Hola directly via the ' + 'site?',
  short: 'Payment'
}, {
  tag: 'h3',
  id: 'version',
  title: `Which ${os} versions does Hola support?`,
  short: `${os} versions support`
}, {
  tag: 'h3',
  id: 'installation',
  title: 'How do I install Hola?',
  short: 'Install Hola'
}, {
  tag: 'h3',
  id: 'using',
  title: 'How do I start using the Hola app?',
  short: 'Using Hola'
}, {
  tag: 'h3',
  id: 'profile-installation',
  title: 'How do I select a country?',
  short: 'Country select'
}, {
  tag: 'h3',
  id: 'turn',
  title: 'How do I turn on/off Hola?'
}, {
  tag: 'h3',
  id: 'uninstall',
  title: 'How do I uninstall the Hola profile?',
  short: 'Uninstall Hola'
}, {
  tag: 'h3',
  id: 'cancel',
  title: 'How do I cancel my subscription',
  short: 'Cancel subscription'
}, {
  tag: 'h3',
  id: 'share',
  title: 'I love Hola app. How can I share my love?',
  short: 'Share Hola'
}, {
  tag: 'h3',
  id: 'reporting',
  title: 'Which information should I provide when reporting a problem?',
  short: 'Report a problem'
}];
var faq_billing_entries = [{
  tag: 'h2',
  id: 'ios',
  title: 'iPhone & iPad',
  short: 'iOS'
}, {
  tag: 'h3',
  id: 'ios-cancel',
  title: 'How do I cancel my Hola Premium subscription?',
  short: 'Cancel account'
}, {
  tag: 'h3',
  id: 'ios-pay',
  title: 'How can I pay for Hola Premium?',
  short: 'How to pay?'
}, {
  tag: 'h3',
  id: 'ios-dup_charge',
  title: 'My account has been charged twice, what should I do?',
  short: 'I chagred twice'
}, {
  tag: 'h3',
  id: 'ios-still_free',
  title: 'I subscribed to Hola Premium but I\'m still on the free ' + 'trial, what should I do?',
  short: 'Subscribed but still on the free trial'
}, {
  tag: 'h3',
  id: 'ios-stop',
  title: 'How do I stop my automatic payments?',
  short: 'Stop automatic payments'
}, {
  tag: 'h3',
  id: 'ios-multi_devices',
  title: 'Can I use my account on multiple devices?',
  short: 'Multiple devices'
}, {
  tag: 'h3',
  id: 'ios-social',
  title: 'How to use my Facebook/Google+ account on iOS?',
  short: 'Social account'
}, {
  tag: 'h2',
  id: 'android',
  title: 'Android devices',
  short: 'Android OS'
}, {
  tag: 'h3',
  id: 'android-cancel',
  title: 'How do I cancel my Hola account?',
  short: 'Cancel account'
}, {
  tag: 'h3',
  id: 'android-pay',
  title: 'How can I pay for Hola Premium?',
  short: 'How to pay?'
}, {
  tag: 'h3',
  id: 'android-dup_charge',
  title: 'My account has been charged twice, what should I do?',
  short: 'I chagred twice'
}, {
  tag: 'h3',
  id: 'android-still_free',
  title: 'I subscribed to Hola Premium but I\'m still on the free ' + 'trial, what should I do?',
  short: 'Subscribed but still on the free trial'
}, {
  tag: 'h3',
  id: 'android-stop',
  title: 'How do I stop my automatic payments?',
  short: 'Stop automatic payments'
}, {
  tag: 'h3',
  id: 'android-multi_devices',
  title: 'Can I use my account on multiple devices?',
  short: 'Multiple devices'
}, {
  tag: 'h3',
  id: 'android-social',
  title: 'How to use my Facebook/Google+ account on Android?',
  short: 'Social account'
}, {
  tag: 'h2',
  id: 'pc',
  title: 'Windows and Mac',
  short: 'PC'
}, {
  tag: 'h3',
  id: 'pc-cancel',
  title: 'How to cancel my Hola account?',
  short: 'Cancel account'
}, {
  tag: 'h3',
  id: 'pc-pay',
  title: 'How can I pay for Hola Premium?',
  short: 'How to pay?'
}, {
  tag: 'h3',
  id: 'pc-dup_charge',
  title: 'My account has been charged twice, what should I do?',
  short: 'I chagred twice'
}, {
  tag: 'h3',
  id: 'pc-still_free',
  title: 'I subscribed to Hola Premium but I\'m still on the free ' + 'trial, what should I do?',
  short: 'Subscribed but still on the free trial'
}, {
  tag: 'h3',
  id: 'pc-multi_devices',
  title: 'Can I use my account on multiple devices?',
  short: 'Multiple devices'
}, {
  tag: 'h3',
  id: 'pc-social',
  title: 'How to use my Facebook/Google+ account on PC?',
  short: 'Social account'
}, {
  tag: 'h2',
  id: 'refund-policy_title',
  title: 'Refund & Cancelation policy'
}, {
  tag: 'h3',
  id: 'refund-policy',
  title: 'Refund & Cancelation policy'
}];
var injected = [];
var add_section = (path, items, icon) => {
  items.forEach(value => {
    if (!value.tech) injected.push(_objectSpread(_objectSpread({}, value), {}, {
      path,
      icon
    }));
  });
};
var ic_size = {
  width: 16,
  height: 16
};
add_section('/support/troubleshooting/windows', content_.desktop.windows.entries, /*#__PURE__*/React.createElement(Icon_windows, ic_size));
add_section('/support/troubleshooting/mac', content_.desktop.mac.entries, /*#__PURE__*/React.createElement(Icon_mac, ic_size));
add_section('/support/troubleshooting/extension', content_.extension.entries, /*#__PURE__*/React.createElement(Icon_chrome, ic_size));
add_section('/support/troubleshooting/ios', content_.mobile.ios.entries, /*#__PURE__*/React.createElement(Icon_ios, ic_size));
add_section('/support/troubleshooting/android', content_.mobile.android.entries, /*#__PURE__*/React.createElement(Icon_android, ic_size));
add_section('/support/troubleshooting/firetv', content_.tv.fire.entries, /*#__PURE__*/React.createElement(Icon_androidtv, ic_size));
add_section('/support/troubleshooting/smarttv', content_.tv.smart.entries, /*#__PURE__*/React.createElement(Icon_androidtv, ic_size));
add_section('/support/troubleshooting/appletv', content_.tv.smart.entries, /*#__PURE__*/React.createElement(Icon_androidtv, ic_size));
add_section('/support/billing', content_.billing.entries);
var all_entries = [...faq_entries.map(e => _objectSpread(_objectSpread({}, e), {}, {
  path: '/faq'
})), ...faq_ios_entries({
  os: 'iOS'
}).map(e => _objectSpread(_objectSpread({}, e), {}, {
  path: '/faq_ios',
  icon: /*#__PURE__*/React.createElement(Icon_ios, ic_size)
})), ...faq_ios_entries({
  os: 'MacOS'
}).map(e => _objectSpread(_objectSpread({}, e), {}, {
  path: '/faq_macos',
  icon: /*#__PURE__*/React.createElement(Icon_mac, ic_size)
})), ...faq_billing_entries.map(e => _objectSpread(_objectSpread({}, e), {}, {
  path: '/faq_billing'
})), ...injected];
var use_faq = props => {
  var q = props.q,
    fn = props.fn,
    _props$entries = props.entries,
    entries = _props$entries === void 0 ? all_entries : _props$entries;
  var res = entries.filter(entry => fn && fn(entry) || entry.title.toLowerCase().includes(q.toLowerCase()));
  return [res];
};
var Search_field = props => {
  var q = props.q,
    on_change = props.on_change,
    on_press = props.on_press,
    on_clear = props.on_clear,
    results = props.results;
  var cls = cn(q && on_clear && 'clear', results && !results.length && 'wrong');
  return /*#__PURE__*/React.createElement("div", {
    className: "search"
  }, q && on_clear && /*#__PURE__*/React.createElement("button", {
    onClick: on_clear
  }), /*#__PURE__*/React.createElement("input", {
    type: "text",
    value: q,
    onChange: on_change,
    className: cls,
    placeholder: "How can we help?",
    onKeyDown: on_press
  }), /*#__PURE__*/React.createElement(Svg, {
    icon: /*#__PURE__*/React.createElement(Icon_loupe, {
      width: 16,
      height: 16
    })
  }));
};
var Search_results = props => {
  var results = props.results;
  return /*#__PURE__*/React.createElement("ul", null, results.map(({
    title,
    to,
    path,
    icon
  }) => /*#__PURE__*/React.createElement("li", {
    key: to
  }, /*#__PURE__*/React.createElement(Link, {
    to: to
  }, /*#__PURE__*/React.createElement("span", {
    className: "with_icon"
  }, icon, title), /*#__PURE__*/React.createElement("span", {
    className: "path"
  }, path)))));
};
var Search = props => {
  var q = props.q,
    results = props.results,
    _props$show_results = props.show_results,
    show_results = _props$show_results === void 0 ? true : _props$show_results;
  return /*#__PURE__*/React.createElement("header", {
    className: "support_search"
  }, /*#__PURE__*/React.createElement("p", null, "Help center"), /*#__PURE__*/React.createElement("h1", {
    className: "title_header"
  }, "Hola VPN Support Center: Setup Guides & Help"), /*#__PURE__*/React.createElement(Tooltip, {
    click_mode: true,
    content: show_results && q && results.length ? /*#__PURE__*/React.createElement(Search_results, {
      results: results,
      q: q
    }) : null,
    cls_cn: "results",
    only_external_close: true
  }, /*#__PURE__*/React.createElement(Search_field, props)), show_results && !results.length && /*#__PURE__*/React.createElement("div", {
    className: "not_found"
  }, "No results for \"", q, "\". Try a different phrasing or check out our ", /*#__PURE__*/React.createElement(Link, {
    to: "/faq"
  }, "FAQ")));
};
var Category_list = ({
  cats,
  opened,
  on_cat_click,
  q,
  cat_close
}) => {
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  return /*#__PURE__*/React.createElement("ul", null, cats.map(cat => {
    var has_sub = (q || opened[cat.id]) && cat.items;
    var cls = cn((q || opened[cat.id]) && 'opened active', !cat.visible_menu && !cat.visible && 'hidden');
    return /*#__PURE__*/React.createElement("li", {
      key: cat.id,
      className: cls
    }, /*#__PURE__*/React.createElement(Link, {
      to: `${pathname}#${cat.id}`,
      onClick: ev => {
        if (cat.tag == 'h2' && opened[cat.id]) cat_close(ev);else on_cat_click(cat);
      }
    }, cat.short || cat.title), has_sub && /*#__PURE__*/React.createElement(Category_list, {
      cats: cat.items,
      opened: opened,
      on_cat_click: on_cat_click
    }));
  }));
};
var Html_player = ({
  nodes
}) => {
  var _useLocation2 = useLocation(),
    pathname = _useLocation2.pathname;
  return /*#__PURE__*/React.createElement(Fragment, null, nodes.map((node, index) => {
    if (!node) return '';
    if (typeof node != 'string') {
      var attrs = _objectSpread({
        key: index
      }, node[2] || {});
      if (attrs.src && attrs.src[0] == '/') attrs.src = config.url2md5(attrs.src);
      if (attrs.href && attrs.href[0] == '#') attrs.href = pathname + attrs.href;
      var children = node[1] && node[1].length ? /*#__PURE__*/React.createElement(Html_player, {
        key: index,
        nodes: node[1]
      }) : undefined;
      return /*#__PURE__*/React.createElement(node[0], attrs, children);
    }
    return node;
  }));
};
var get_real_offset = el => {
  var offset_top = el.offsetTop || 0;
  while (el.parentElement) {
    el = el.parentElement;
    offset_top += el.offsetTop;
  }
  return offset_top;
};
var scroll_to = id => {
  var el = document.getElementById(id);
  if (!el) return;
  window.scrollTo({
    top: get_real_offset(el) - 160,
    behavior: 'auto'
  });
};
var Faq_page = props => {
  var q = props.q,
    entries = props.entries,
    content = props.content,
    intro = props.intro,
    _props$show_back = props.show_back,
    show_back = _props$show_back === void 0 ? true : _props$show_back,
    wrapper = props.wrapper,
    closable = props.closable,
    no_observe = props.no_observe;
  var state = useMemo(() => ({
    refs: {},
    observer: null
  }), []);
  var h3s = entries.map(({
    id
  }) => id);
  var history = useHistory();
  var _useLocation3 = useLocation(),
    hash = _useLocation3.hash,
    pathname = _useLocation3.pathname;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    set_active = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    opened = _useState4[0],
    set_opened = _useState4[1];
  var cat_close = ev => {
    set_opened({});
    ev && ev.preventDefault();
  };
  var cat_open = item => {
    var path = {
      [item.id]: true
    };
    for (var parent = item.parent; parent; parent = parent.parent) path[parent.id] = true;
    set_opened(path);
    if (path[item.id]) set_active(item.id);
  };
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    inview = _useState6[0],
    set_inview = _useState6[1];
  var _convert_to_tree = convert_to_tree(entries, q),
    tree = _convert_to_tree.tree,
    map = _convert_to_tree.map;
  var on_intersect = _entries => {
    var changed = _entries.reduce((a, v) => {
      a[v.target.id] = v.isIntersecting;
      return a;
    }, {});
    set_inview(v => _objectSpread(_objectSpread({}, v), changed));
  };
  useEffect(() => {
    var _hash = hash && hash.slice(1) || '';
    if (no_observe) {
      if (hash && map[_hash]) {
        setTimeout(() => scroll_to(_hash), 100);
        return void cat_open(map[_hash]);
      }
      return void set_opened({
        [tree[0].id]: true
      });
    }
    var item = map[_hash];
    if (item) cat_open(item);
    if ('IntersectionObserver' in window) {
      state.observer = new IntersectionObserver(on_intersect, {
        thresholds: [0, 1]
      });
      if (state.observer) {
        var elements = Object.keys(state.refs).map(r => state.refs[r].current);
        elements.forEach(el => state.observer.observe(el));
      }
    }
    return () => {
      if (!state.observer) return;
      state.observer.disconnect();
      state.observer = null;
    };
  }, []);
  useEffect(() => {
    var first = h3s.find(id => inview[id]);
    if (!first) return;
    set_active(first);
    var cat = map[first];
    if (cat) cat_open(cat);
  }, [inview]);
  useEffect(() => {
    var new_id = hash.slice(1);
    set_active(new_id);
    if (no_observe) scroll_to(new_id);
  }, [hash]);
  return /*#__PURE__*/React.createElement("main", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "side_menu-wrapper"
  }, show_back && /*#__PURE__*/React.createElement("button", {
    className: "back_btn",
    onClick: () => history.goBack()
  }, "Back"), /*#__PURE__*/React.createElement("aside", {
    className: "side_menu"
  }, /*#__PURE__*/React.createElement(Category_list, {
    cats: tree,
    opened: opened,
    on_cat_click: cat_open,
    cat_close: cat_close
  })), /*#__PURE__*/React.createElement("div", {
    className: "bottom"
  })), /*#__PURE__*/React.createElement("section", {
    className: "hola_faq-content"
  }, intro && /*#__PURE__*/React.createElement(Html_player, {
    nodes: intro
  }), entries.map(({
    id,
    title,
    tag: Tag,
    html,
    note
  }) => {
    var ref = state.refs[id] = useRef();
    var hide_tag = q && !map[id].visible;
    var cls = cn(id == active && 'active', hide_tag && 'hidden', closable && 'title_pointer');
    var on_click = () => {
      if (closable) {
        set_active(active == id ? null : id);
        set_opened({
          [map[id].parent.id]: true,
          [id]: true
        });
        history.push(`${pathname}#${id}`);
      }
    };
    return wrapper ? /*#__PURE__*/React.createElement("div", {
      key: id,
      className: cn(wrapper, `${wrapper}--${Tag}`)
    }, /*#__PURE__*/React.createElement(Tag, {
      id: id,
      ref: ref,
      className: cls,
      onClick: on_click
    }, title), !hide_tag && (html ? /*#__PURE__*/React.createElement(Html_player, {
      nodes: html
    }) : content[id]), closable && /*#__PURE__*/React.createElement("span", {
      className: `${wrapper}-close`,
      onClick: on_click
    })) : /*#__PURE__*/React.createElement(Fragment, {
      key: id
    }, /*#__PURE__*/React.createElement(Tag, {
      id: id,
      ref: ref,
      className: cls
    }, /*#__PURE__*/React.createElement(Link, {
      to: `${pathname}#${id}`
    }, title)), !hide_tag && note && /*#__PURE__*/React.createElement("p", {
      className: "note"
    }, note), !hide_tag && (html ? /*#__PURE__*/React.createElement(Html_player, {
      nodes: html
    }) : content[id]));
  })));
};
var Refund_text = () => (zutil.get(hopt, 'www_hola.refund_funnel') || {}).enabled ? /*#__PURE__*/React.createElement(Fragment, null, "submit a ", /*#__PURE__*/React.createElement(Link, {
  to: "/refund"
}, "refund request"), ".") : /*#__PURE__*/React.createElement(Fragment, null, "fill in a ", /*#__PURE__*/React.createElement("a", {
  href: "/premium_support?ref=faq"
}, "support form"), " or contact us by ", /*#__PURE__*/React.createElement("a", {
  href: "mailto:billing2@hola.org"
}, "email"), ".");
var YesNo = props => {
  var _props$q = props.q,
    q = _props$q === void 0 ? 'Was this article helpful?' : _props$q,
    yes = props.yes,
    no = props.no,
    id = props.id,
    state = props.state,
    step = props.step,
    redir = props.redir;
  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("div", {
    className: cn('yes_no', state[id] && state[id][step])
  }, /*#__PURE__*/React.createElement("span", null, q), /*#__PURE__*/React.createElement("button", {
    className: "yes",
    onClick: yes({
      id,
      step,
      q
    })
  }, /*#__PURE__*/React.createElement(Svg, {
    icon: /*#__PURE__*/React.createElement(Icon_thumb_up, {
      width: 20,
      height: 20
    })
  }), "Yes"), /*#__PURE__*/React.createElement("button", {
    className: "no",
    onClick: no({
      id,
      step,
      redir,
      q
    })
  }, /*#__PURE__*/React.createElement(Svg, {
    icon: /*#__PURE__*/React.createElement(Icon_thumb_up, {
      width: 20,
      height: 20
    })
  }), "No")));
};
var id2name = {
  ios: 'iOS',
  firetv: 'Fire TV',
  smarttv: 'Smart TV',
  appletv: 'Apple TV',
  extension: 'Browser Extension',
  billing: 'Billing and Payments',
  androidtv: 'Android TV'
};
var get_path_name = id => id2name[id] || string.capitalize(id);
var Breadcrumbs = ({
  root,
  divider = '/'
}) => {
  var _useLocation4 = useLocation(),
    pathname = _useLocation4.pathname;
  var parts = pathname.slice(1).split('/').filter(v => !!v);
  return /*#__PURE__*/React.createElement("div", {
    className: "breadcrumbs"
  }, parts.map((part, index) => {
    var id = root && index == 0 ? root : part;
    var to = `/${parts.slice(0, index + 1).join('/')}`;
    var cls = cn('part', {
      active: index == parts.length - 1
    });
    return /*#__PURE__*/React.createElement(Fragment, {
      key: part
    }, index > 0 && /*#__PURE__*/React.createElement("span", {
      className: "divider"
    }, divider), /*#__PURE__*/React.createElement(Link, {
      className: cls,
      to: to
    }, get_path_name(id)));
  }));
};
var Support_request = () => {
  var history = useHistory();
  var on_click = () => {
    history.push('/premium_support');
  };
  return /*#__PURE__*/React.createElement("section", {
    className: "support_request"
  }, /*#__PURE__*/React.createElement("span", null, "Our friendly support team are here to help you out!"), /*#__PURE__*/React.createElement(Button, {
    round: true,
    on_click: on_click,
    arrow: true,
    caption: "Submit a request"
  }));
};
var perrs_sent = {};
var qa_perr = (val, src, text, opt) => {
  var id = opt.id,
    step = opt.step,
    q = opt.q;
  var _id = `${src}-${id}-${step}-${val}`;
  if (perrs_sent[_id]) return;
  www_util.perr({
    id: `www_support_answer_${val}`,
    info: {
      text,
      src,
      step,
      q
    }
  });
  perrs_sent[_id] = 1;
};
export { faq_entries, faq_ios_entries, faq_billing_entries, use_faq, Search, Faq_page, Refund_text, convert_to_tree, YesNo, Breadcrumbs, get_path_name, qa_perr, Support_request };